export default __webpack_public_path__ + "static/feature_4-13df1868f196e3f215aeb0a216eed2b5.png";